import axios from "axios";

export const getSimCards = async iccidCodes => {
  const response = await axios.get(
    `/api/simcards?iccidCodes=${iccidCodes.join("|")}`
  );
  return response.data;
};

export const importSimCards = async simcards => {
  const response = await axios.post(`/api/simcards`, { simcards });
  return response.data;
};

export const createSim = async sim => {
  const response = await axios.put(`/api/simcards`, { sim });
  return response.data;
};

export const updateSim = async sim => {
  const response = await axios.patch(`/api/simcards`, { sim });
  return response.data;
};

export const getSim = async id => {
  const response = await axios.get(`/api/simcards/${id}`);
  return response.data;
};

export const deleteSim = async id => {
  const response = await axios.delete(`/api/simcards/${id}`);
  return response.data;
};
